// assets/section-main-product.js
// Variant Selection Logic
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
    if (this.currentVariant) {
      const form = document.querySelector('#product-form-main');
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
      }
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

// Product Media Engine JS
if (!customElements.get('product-media-engine')) {
  class ProductMediaEngine extends HTMLElement {
    constructor() {
      super();
      this.mainCarousel = this.querySelector('[data-media-main]');
      this.thumbnails = this.querySelectorAll('[data-thumbnail-id]');
      
      if (!this.mainCarousel || this.thumbnails.length === 0) return;

      this.bindEvents();
      this.initObserver();
    }

    bindEvents() {
      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const id = thumb.getAttribute('data-thumbnail-id');
          const targetMedia = this.mainCarousel.querySelector(`[data-media-id="${id}"]`);
          if (targetMedia) {
            this.mainCarousel.scrollTo({
              left: targetMedia.offsetLeft,
              behavior: 'smooth'
            });
          }
        });
      });
    }

    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('data-media-id');
            this.updateActiveThumbnail(id);
          }
        });
      }, {
        root: this.mainCarousel,
        threshold: 0.6 // Trigger when 60% of the item is visible
      });

      const items = this.mainCarousel.querySelectorAll('.pro-gallery__item');
      items.forEach(item => this.observer.observe(item));
    }

    updateActiveThumbnail(id) {
      this.thumbnails.forEach(thumb => {
        if (thumb.getAttribute('data-thumbnail-id') === id) {
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-selected', 'true');
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-selected', 'false');
        }
      });
    }
  }


  customElements.define('product-media-engine', ProductMediaEngine);
}
